import { AlertSeverity } from './alert.interface';

// TODO: its available q-ngc lib but need to add to public-api. add to public-api and remove from here.
export interface ApiResponseInterface<T> {
    data: T;
}

// TODO: its available q-ngc lib but need to add to public-api. add to public-api and remove from here.
export class ApiResponse<T> {
    public data: T;

    constructor(data: T) {
        this.data = data;
    }
}

export interface BulkApiResponseInterface<T> {
    isSuccess: boolean;
    data?: T; // response data on success
    error?: ApiErrorInterface; // error information if failed
    id?: number | string; // id of current item if failed
}

export interface ApiErrorInterface {
    message: string;
    displayToUser: boolean;
    rawError?: any;
    severity?: AlertSeverity;
}

export class ApiError extends Error implements ApiErrorInterface {
    /**
     * Constructs a frontend friendly error object containing messages
     * that can be displayed to users.
     */
    constructor(
        public message: string,
        public status: number,
        public displayToUser: boolean = true,
        public rawError: any = {},
        public severity: AlertSeverity = AlertSeverity.DANGER
    ) {
        super(message);

        // Babel 5 does not transpile extension of native object types.
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ApiError.prototype);
    }

    toJSON(): any {
        return {
            message: this.message,
            status: this.status,
            displayToUser: this.displayToUser,
            rawError: this.rawError,
            severity: this.severity
        };
    }
}

export interface CPAConflictError {
    code: number;
    context: {
        $ref: string;
        value: string;
    }[];
    message: string;
    type: string;
}
